import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { FadeSwiper, SvgIcon } from '../../Molecules';

import styles from './AllHorizontalRow.module.css';

export type AllHorizontalRowProps<T> = {
  sectionTitle: string;
  items: T[];
  onClickAll: () => void;
  children: (item: T) => ReactNode;
};

export const AllHorizontalRow = <T,>(props: AllHorizontalRowProps<T>) => {
  const { sectionTitle, items, onClickAll, children } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.title}>{t(sectionTitle)}</p>
        <div className={styles.allButton} onClick={onClickAll}>
          <span>{t('All')}</span>
          <SvgIcon
            name={SVGIconType.Arrow}
            color="#808080"
            width={16}
            height={16}
          />
        </div>
      </div>
      <FadeSwiper<T> items={items}>{(item: T) => children(item)}</FadeSwiper>
    </div>
  );
};
